import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('gd-shimmer rounded-sm motion-reduce:animate-none', className)}
      aria-hidden="true"
      {...props}
    />
  )
}
